import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { multilanguage, changeLanguage } from "redux-multilanguage";
import { connect } from "react-redux";
import {
    globalURL,
    fetchApiHeaders
} from "../../../../../constants";

const MobileNavMenu = ({ display, login, strings, products, categories, user, currentLanguageCode, changeLanguage, dispatch }) => {
    const changeLanguageTrigger = (languageCode) => {
        dispatch(changeLanguage(languageCode));
        if (login.user !== null) {
            fetch(globalURL + "/user/updateUserLanguage", {
                method: 'POST',
                headers: {
                    ...fetchApiHeaders.POST,
                    token: login.user.token
                },
                body: JSON.stringify({
                    language: languageCode
                })
            })
        }
    };

    return (
        <nav style={{ display: display }} className="offcanvas-navigation" id="offcanvas-navigation">

            <div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                    <i style={{ fontSize: 24, marginRight: 15 }} className="pe-7s-user"></i>
                    {
                        user === null ? <div style={{ flexDirection: "column", display: "flex" }}>
                            <label style={{ fontSize: 16 }}>{String(strings['header']['iconMenu']['myAccount']).toLocaleUpperCase("tr-TR")}</label>
                            <small> {strings["info"]['login']}</small>
                            <a className="default-btn col-md-12 text-center mt-15" href="/login-register/login">
                                {String(strings['header']['iconMenu']['login']).toLocaleUpperCase("tr-TR")}
                            </a>
                        </div> : <div style={{ flexDirection: "column", display: "flex" }}>
                            <label style={{ fontSize: 15, marginTop: -5 }}>{String(user.name).toLocaleUpperCase("tr-TR")}</label>
                            <label style={{ fontSize: 15, marginTop: -10 }}>{String(user.surname).toLocaleUpperCase("tr-TR")}</label>

                        </div>
                    }
                </div>
            </div>
            <hr />





            <ul>
                {
                    user !== null ?
                        <li className="menu-item-has-children">
                            <div style={{ fontSize: 16 }} className="nav-menu">{String(strings['header']['iconMenu']['myAccount']).toLocaleUpperCase("tr-TR")}</div>
                            <ul className="sub-menu">
                                <li>
                                    <a href="/my-account/detail">{String(strings['header']['iconMenu']['myAccount']).toLocaleUpperCase("tr-TR")}</a>
                                </li>
                                <li>
                                    <a href="/my-orders">{String(strings['header']['iconMenu']['myOrders']).toLocaleUpperCase("tr-TR")}</a>
                                </li>
                                <li>
                                    <a href="/my-refunds">{String(strings['header']['iconMenu']['myRefunds']).toLocaleUpperCase("tr-TR")}</a>
                                </li>
                            </ul>
                        </li> : null
                }
                <li className="menu-item-has-children">
                    <div style={{ fontSize: 16 }} className="nav-menu">{strings['appPages']['navShop']}</div>
                    <ul className="sub-menu">
                        {
                            categories.map((item, i) => {
                                return <li key={i}>
                                    <a href={process.env.PUBLIC_URL + "/shop?category=" + item.categoryCode}>
                                        {String(item.categoryName[currentLanguageCode]).toLocaleUpperCase(currentLanguageCode)}
                                    </a>
                                </li>
                            })
                        }
                    </ul>
                </li>
                <li className="menu-item-has-children">
                    <div style={{ fontSize: 16 }} className="nav-menu">{strings['appPages']['newSeason']}</div>
                    <ul className="sub-menu">
                        {
                            products.map((item, i) => {
                                return <li key={i}>
                                    <a style={{ fontSize: 14 }} href={process.env.PUBLIC_URL + "/shop?product=" + item.seoName}>
                                        {String(item.productName[currentLanguageCode]).toLocaleUpperCase(currentLanguageCode)}
                                    </a>
                                </li>
                            })
                        }
                    </ul>
                </li>
                <li style={{ fontSize: 16 }}>
                    <Link to={process.env.PUBLIC_URL + "/about"}>
                        {strings["about_us"]}
                    </Link>
                </li>
                <li style={{ fontSize: 16 }}>
                    <Link to={process.env.PUBLIC_URL + "/contact"}>
                        {strings["contact_us"]}
                    </Link>
                </li>
                <li className="menu-item-has-children">
                    <div style={{ fontSize: 16 }} className="nav-menu">{"LANGUAGE"}</div>
                    <ul className="sub-menu">
                        <li>
                            <a style={{ textDecorationLine: currentLanguageCode === "tr" ? "underline" : "none" }} onClick={() => {
                                changeLanguageTrigger("tr");
                            }}>TÜRKÇE</a>
                        </li>
                        <li>
                            <a style={{ textDecorationLine: currentLanguageCode === "eng" ? "underline" : "none" }} onClick={() => {
                                changeLanguageTrigger("eng");
                            }}>ENGLISH</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    );
};

MobileNavMenu.propTypes = {
    strings: PropTypes.object
};


const mapStateToProps = state => {
    return {
        currency: state.currencyData,
        login: state.login
    };
};

export default connect(
    mapStateToProps,
    {
        changeLanguage
    }
)(multilanguage(MobileNavMenu));